import { render, staticRenderFns } from "./CustomerTotalOutstandingNumberDisplayer.vue?vue&type=template&id=679e3f32"
import script from "./CustomerTotalOutstandingNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerTotalOutstandingNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports